// First-party attribution, same cookie and fields as fiberfed.com (ff_attr, Domain=.fiberfed.com).
const KEY = "ff_attr";
const DAYS = 90;
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "li_fat_id"];

const readCookie = () => {
  const match = document.cookie.match("(?:^|; )" + KEY + "=([^;]*)");
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch (e) {
    return null;
  }
};

const writeCookie = (value) => {
  const expires = new Date(Date.now() + DAYS * 864e5).toUTCString();
  const domain = /fiberfed\.com$/.test(window.location.hostname) ? "; domain=.fiberfed.com" : "";
  document.cookie = KEY + "=" + encodeURIComponent(JSON.stringify(value)) + "; expires=" + expires + "; path=/" + domain + "; SameSite=Lax; Secure";
};

export const getAttribution = () => {
  const now = new Date().toISOString();
  const search = new URLSearchParams(window.location.search);
  const found = {};
  PARAMS.forEach((key) => {
    const value = search.get(key);
    if (value) found[key] = value;
  });
  let current = readCookie();
  if (!current || typeof current !== "object") {
    current = { landing_page: window.location.href.slice(0, 500), referrer: (document.referrer || "").slice(0, 500), first_ts: now, last_ts: now, ...found };
    writeCookie(current);
  } else if (Object.keys(found).length) {
    current = { ...current, ...found, last_ts: now };
    writeCookie(current);
  }
  return current;
};

// Mixpanel properties: the click IDs are reduced to yes/no.
export const attributionProps = () => {
  const attr = getAttribution();
  return {
    site: "finder.fiberfed.com",
    utm_source: attr.utm_source,
    utm_medium: attr.utm_medium,
    utm_campaign: attr.utm_campaign,
    utm_term: attr.utm_term,
    utm_content: attr.utm_content,
    first_landing_page: attr.landing_page,
    first_referrer: attr.referrer,
    has_gclid: !!attr.gclid,
    has_fbclid: !!attr.fbclid,
    has_li_fat_id: !!attr.li_fat_id,
  };
};
